import { folderApi } from "./api.service";

export interface AuditLogCriteria {
    pageNo?: number;
    pageSize?: number;
    sortBy?: string;
    sortDir?: "asc" | "desc";
}

export interface AuditLog {
    id: number;
    createdAt: string;
    method: string;
    operation: string;
    requestUri: string;
    queryString?: string;
    statusCode: number;
    ipAddress: string;
    userId: number;
    username: string;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
}

export interface AuditLogsPage {
    content: AuditLog[];
    totalElements: number;
    totalPages: number;
    number: number;
    size: number;
    numberOfElements: number;
    first: boolean;
    last: boolean;
    empty: boolean;
}

export interface AuditLogsResponse {
    code: string;
    data: AuditLogsPage;
    message: string;
    result: boolean;
}

export const getAuditLogs = async ({
    pageNo = 0,
    pageSize = 50,
    sortBy = "createdAt",
    sortDir = "desc",
}: AuditLogCriteria = {}) => {
    return await folderApi.get<AuditLogsResponse>(
        `/audit/v1/logs?pageNo=${pageNo}&pageSize=${pageSize}&sortBy=${encodeURIComponent(sortBy)}&sortDir=${sortDir}`
    ).catch((e) => e);
};
